import { createSelector } from '@reduxjs/toolkit';

import { specialPromosBlocksSelector } from './specialPromosBlocksSelector';

export const developerRatingsSelector = createSelector(specialPromosBlocksSelector, state => state.developerRatings);
